import * as Yup from 'yup';

export default Yup.object({
  pin: Yup.string()
    .length(4, 'PIN must be 4 digits')
    .required('Please enter a PIN'),
});
